import { h } from '@atomify/jsx';

interface ButtonInterface {
    label: string | Text;
    variant?: string;
    icon?: string;
    size?: string;
    classes?: string;
    type?: string;
    url?: string;
    hook?: string;
    controls?: string;
    onClick?: Function;
    target?: string;
    attr?: {};
}

const createClassName = (data: ButtonInterface) => {
    let className = data.variant ? `c-button--${data.variant}` : 'c-button';

    className += data.icon ? ' button--icon' : '';
    className += data.size ? ` button--${data.size}` : '';
    className += data.classes ? ` ${data.classes}` : '';

    return className;
};

const createAttributes = (data: ButtonInterface) => {
    const attributes: any = {
        ...data.attr,
        [`js-hook-${data.hook}`]: data.hook,
        onClick: data.onClick,
        ariaControls: data.controls,
        href: data.url,
    };

    return attributes;
};

/*
    <button> element
*/
const Button = (data: ButtonInterface) => {
    const className = createClassName(data);
    const attributes = createAttributes(data);

    attributes.type = data.type || 'button';

    return (
        <button class={className} {...attributes}>
            {data.icon && (
                <span class="button__icon">
                    <bpd-svg name={data.icon}></bpd-svg>
                </span>
            )}

            <span class="button__label">{data.label}</span>
        </button>
    );
};

/*
    <a> element
*/
const ButtonA = (data: ButtonInterface) => {
    const className = createClassName(data);
    const attributes = createAttributes(data);

    return (
        <a class={className} {...attributes} target={data.target}>
            {data.icon && (
                <span class="button__icon">
                    <bpd-svg name={data.icon}></bpd-svg>
                </span>
            )}

            <span class="button__label">{data.label}</span>
        </a>
    );
};

export { Button, ButtonA };
